import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Section from '../components/common/Section';
import Button from '../components/common/Button';

const ContactContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  margin-top: 2rem;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr 1fr;
  }
`;

const ContactInfo = styled.div`
  background-color: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 2rem;
  box-shadow: ${props => props.theme.shadows.small};
`;

const InfoItem = styled.div`
  margin-bottom: 1.5rem;
`;

const InfoTitle = styled.h4`
  color: ${props => props.theme.colors.primary};
  margin-bottom: 0.5rem;
`;

const InfoText = styled.p`
  color: ${props => props.theme.colors.lightText};
`;

const ContactForm = styled.form`
  background-color: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 2rem;
  box-shadow: ${props => props.theme.shadows.small};
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const FormLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: ${props => props.theme.colors.darkText};
`;

const FormInput = styled.input`
  width: 100%;
  padding: 0.8rem;
  border: 1px solid ${props => props.theme.colors.lightGray};
  border-radius: ${props => props.theme.borderRadius.small};
`;

const FormTextarea = styled.textarea`
  width: 100%;
  padding: 0.8rem;
  border: 1px solid ${props => props.theme.colors.lightGray};
  border-radius: ${props => props.theme.borderRadius.small};
  min-height: 150px;
`;

const Contact = () => {
  const { t } = useTranslation();
  
  return (
    <div>
      <Section 
        title={t('contact.title')} 
        subtitle={t('contact.subtitle')}
      >
        <ContactContainer>
          <ContactInfo>
            <InfoItem>
              <InfoTitle>{t('contact.info.address')}</InfoTitle>
              <InfoText>123 Tech Street, Shanghai, China</InfoText>
            </InfoItem>
            <InfoItem>
              <InfoTitle>{t('contact.info.email')}</InfoTitle>
              <InfoText>info@imeettech.com</InfoText>
            </InfoItem>
            <InfoItem>
              <InfoTitle>{t('contact.info.phone')}</InfoTitle>
              <InfoText>+86 123 4567 8910</InfoText>
            </InfoItem>
            <InfoItem>
              <InfoTitle>{t('contact.info.hours')}</InfoTitle>
              <InfoText>9:00-18:00 (Mon-Fri)</InfoText>
            </InfoItem>
          </ContactInfo>
          
          <ContactForm>
            <FormGroup>
              <FormLabel>{t('contact.form.name')}</FormLabel>
              <FormInput type="text" required />
            </FormGroup>
            <FormGroup>
              <FormLabel>{t('contact.form.email')}</FormLabel>
              <FormInput type="email" required />
            </FormGroup>
            <FormGroup>
              <FormLabel>{t('contact.form.subject')}</FormLabel>
              <FormInput type="text" required />
            </FormGroup>
            <FormGroup>
              <FormLabel>{t('contact.form.message')}</FormLabel>
              <FormTextarea required />
            </FormGroup>
            <Button type="submit" variant="secondary">
              {t('contact.form.submit')}
            </Button>
          </ContactForm>
        </ContactContainer>
      </Section>
    </div>
  );
};

export default Contact;